import React, { useCallback, useState } from 'react'
import BaseInputs from '@/components/codeLists/baseInputs'
import DateValidInputs from '@/components/codeLists/dateValidInputs'
import NationalIdFormatInput from '@/components/codeLists/nationalIdFormatInput'

const NationalIdFormatItemForm = function (props) {
  const [formValues, setFormValues] = useState({
    id: props.item.id || undefined,
    name: props.item.name || '',
    latinName: props.item.latinName || '',
    code: props.item.code || '',
    legacyCode: props.item.legacyCode || undefined,
    validFrom: props.item.validFrom || new Date(),
    validTo: props.item.validTo || null,
    nationalIdFormat: props.item.nationalIdFormat || ''
  })

  const handleBaseInputsChange = useCallback((values) => {
    setFormValues(prevValues => {
      const newValues = {
        ...prevValues,
        ...values
      }
      props.onChange(newValues)
      return newValues
    })
  }, [props])

  const handleDateValidInputsChange = useCallback((values) => {
    setFormValues(prevValues => {
      const newValues = {
        ...prevValues,
        validFrom: values.validFrom,
        validTo: values.validTo
      }
      props.onChange(newValues)
      return newValues
    })
  }, [props])

  const handleNationalIdFormatChange = useCallback((value) => {
    setFormValues(prevValues => {
      const newValues = {
        ...prevValues,
        nationalIdFormat: value
      }
      props.onChange(newValues)
      return newValues
    })
  }, [props])

  return (
    <div>
      <BaseInputs
        name={formValues.name}
        latinName={formValues.latinName}
        code={formValues.code}
        legacyCode={formValues.legacyCode}
        isReadOnly={props.isReadOnly}
        onChange={handleBaseInputsChange}
      />
      <DateValidInputs
        validFrom={formValues.validFrom}
        validTo={formValues.validTo}
        isReadOnly={props.isReadOnly}
        onChange={handleDateValidInputsChange}
      />
      <NationalIdFormatInput
        value={formValues.nationalIdFormat}
        isReadOnly={props.isReadOnly}
        onChange={handleNationalIdFormatChange}
      />
    </div>
  )
}

export default NationalIdFormatItemForm



// WEBPACK FOOTER //
// ./src/components/codeLists/nationalIdFormatItemForm.js